import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
  OnDestroy,
  NgZone,
  inject,
  DOCUMENT,
  Renderer2,
} from '@angular/core';
import { cueClose, IconComponent } from '@cue/ui/icons';
import { QrCodeViewerComponent } from '../qr-code-viewer/qr-code-viewer.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';
import { explicitEffect } from 'ngxtension/explicit-effect';
import { CdkConnectedOverlay, Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'cue-external-url-qr',
  imports: [IconComponent, QrCodeViewerComponent, TranslocoPipe, CdkConnectedOverlay],
  templateUrl: './external-url-qr.component.html',
  styleUrl: './external-url-qr.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalUrlQrComponent implements OnDestroy {
  ICONS = {
    cueClose,
  };

  kioskId = input.required<string | null>();
  document = inject(DOCUMENT);
  renderer = inject(Renderer2);
  zone = inject(NgZone);
  overlay = inject(Overlay);
  globalOverlay = this.overlay.position().global().centerHorizontally().centerVertically() as any;

  externalUrl = signal<string | null | undefined>(undefined);
  externalUrlTitleName = computed(() => {
    const externalUrl = this.externalUrl();
    if (!externalUrl) {
      return null;
    }
    const parsedUrl = new URL(externalUrl);
    return parsedUrl.searchParams.get('resourceName');
  });

  descriptionText = computed(() => {
    if (this.externalUrlTitleName()) {
      return translation.webapps.scanQrToReserveViaCueAssist;
    }
    return null;
  });

  _bindListener?: () => void;
  private bindAModal() {
    this.unbindAModal();
    this.zone.runOutsideAngular(() => {
      this._bindListener = this.renderer.listen(this.document, 'click', (event: MouseEvent) => {
        if ((event.target as HTMLElement).nodeName.toUpperCase() === 'A') {
          const href = (event.target as HTMLAnchorElement).href;
          const outsidecurrentDomain = href != null && href != '' && !href.startsWith(window.location.origin);
          if (outsidecurrentDomain) {
            this.zone.run(() => {
              event.preventDefault();
              this.externalUrl.set(href);
            });
          }
        }
      });
    });
  }

  private unbindAModal() {
    if (this._bindListener) {
      this._bindListener();
      this._bindListener = undefined;
    }
  }

  kioskBindingEffect = explicitEffect([this.kioskId], ([kioskId]) => {
    if (kioskId) {
      this.bindAModal();
    } else {
      this.unbindAModal();
    }
  });

  ngOnDestroy() {
    this.unbindAModal();
  }

  public hide(): void {
    this.externalUrl.set(null);
  }

  protected readonly translation = translation;
}
